import api from "./api";

export const fetchPendingCommissions = async (
    page = 1,
    size = 10
) => {
    try {
        const response = await api.get(
            `/driver-partner-management/referral-milestones/pending-commissions?page=${page}&size=${size}`
        );

        if (
            response.status === 200 &&
            response.data.success
        ) {
            return {
                success: true,
                data: response.data.data,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };
    } catch (error) {
        console.error(
            "Error fetching pending commissions:",
            error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch pending commissions",
        };
    }
};